import '.be{position:fixed;}.ssr-plugin'
import '.bf{inset:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.c2{background-color:rgba(0,0,0,0.3);}.ssr-plugin'
import '.ac{padding:16px;}.ssr-plugin'
import '.c3{z-index:1;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.c4{max-width:600px;}.ssr-plugin'
import '.c5{border-radius:16px;}.ssr-plugin'
import '.c6{z-index:2;}.ssr-plugin'
import '.c7{height:90vh;}.ssr-plugin'
import '.c8{max-height:720px;}.ssr-plugin'
import '.a0{position:relative;}.ssr-plugin'
import '.bg{overflow:hidden;}.ssr-plugin'
import '.c9{padding-bottom:96px;}.ssr-plugin'
import '.v{justify-content:space-between;}.ssr-plugin'
import '.ca{padding:32px 16px 16px 16px;}.ssr-plugin'
import '.p{border:none;}.ssr-plugin'
import '.cb{background-color:transparent;}.ssr-plugin'
import '.cc{aspect-ratio:1/1;}.ssr-plugin'
import '.cd{width:32px;}.ssr-plugin'
import '.q{cursor:pointer;}.ssr-plugin'
import '.ce{padding:6px;}.ssr-plugin'
import '.cf{border-radius:4px;}.ssr-plugin'
import '.cg{padding-left:16px;}.ssr-plugin'
import '.ch{padding-right:16px;}.ssr-plugin'
import '.ci{overflow-y:scroll;}.ssr-plugin'
import '.cj{max-height:540px;}.ssr-plugin'
import '.ck{text-align:right;}.ssr-plugin'
import '.a2{position:absolute;}.ssr-plugin'
import '.by{left:0px;}.ssr-plugin'
import '.c0{right:0px;}.ssr-plugin'
import '.ab{bottom:0px;}.ssr-plugin'
import React, { useEffect } from 'react'
import { styled } from 'inlines'
import { Text } from './Text'
import { Button } from './Button'
import { useTheme } from '../providers/useTheme'
import { useIsMobile } from '../hooks/useIsMobile'
import { useTranslations } from '../hooks/useTranslations'
import { Html } from './Html'

export const TermsModal = ({ setShowTermsModal }) => {
  const { colors } = useTheme()
  const isMobile = useIsMobile()

  const { data: navDic = {} } = useTranslations('navigation')
  const { data: legalDic = {} } = useTranslations('legal')

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className="be bf a b c c2 ac c3"
      onClick={() => setShowTermsModal(false)}
    >
      <div className="h c4 c5 c6 c7 c8 a0 bg c9"
        style={{
          background: colors.background,}}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="a b v ca"
        >
          <Text variant="subtitle" color="gradient" style={{ fontWeight: 700 }}>
            {navDic.terms_and_conditions_title}
          </Text>
          <styled.button className="p cb cc cd a b c q ce cf"
            style={{
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.06)',
              },
            }}
            onClick={() => setShowTermsModal(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
            >
              <path
                d="M6.1135 6.82125L0.86725 12.0672C0.77375 12.1609 0.659 12.2109 0.523 12.2172C0.387167 12.2238 0.266083 12.1737 0.15975 12.0672C0.05325 11.9609 0 11.843 0 11.7135C0 11.584 0.05325 11.4661 0.15975 11.3597L5.40575 6.1135L0.15975 0.86725C0.0660833 0.77375 0.0160833 0.659 0.00974999 0.523C0.00324999 0.387166 0.05325 0.266082 0.15975 0.159749C0.266083 0.0532488 0.384 0 0.5135 0C0.643 0 0.760916 0.0532488 0.86725 0.159749L6.1135 5.40575L11.3597 0.159749C11.4532 0.0660822 11.568 0.0160822 11.704 0.00974884C11.8398 0.00324884 11.9609 0.0532488 12.0673 0.159749C12.1737 0.266082 12.227 0.383999 12.227 0.513499C12.227 0.642999 12.1737 0.760917 12.0673 0.86725L6.82125 6.1135L12.0673 11.3597C12.1609 11.4532 12.2109 11.568 12.2172 11.704C12.2238 11.8398 12.1737 11.9609 12.0673 12.0672C11.9609 12.1737 11.843 12.227 11.7135 12.227C11.584 12.227 11.4661 12.1737 11.3597 12.0672L6.1135 6.82125Z"
                fill={colors.textPrimary}
                fillOpacity="0.6"
              />
            </svg>
          </styled.button>
        </div>

        <div className="cg ch ci cj"
          style={{
            marginBottom: isMobile ? '96px' : '32px',}}
        >
          <Html color={colors.textSecondary} variant="subheading-regular">
            {legalDic.terms_and_conditions}
          </Html>
        </div>
        <div className="ac ck a2 by c0 ab"
          style={{
            borderTop: `1px solid ${colors.border}`,
            background: colors.background,}}
        >
          <Button
            id="modal-terms-close"
            on={{
              click: () => setShowTermsModal(false),
            }}
            style={{ width: isMobile ? '100%' : 'inherit' }}
          >
            <Text color={colors.background} variant="display-medium">
              {navDic.close_button}
            </Text>
          </Button>
        </div>
      </div>
    </div>
  )
}
